import { render } from "./InfoClienteRepeticao.vue?vue&type=template&id=46cf5a0b&scoped=true"
import script from "./InfoClienteRepeticao.vue?vue&type=script&lang=js"
export * from "./InfoClienteRepeticao.vue?vue&type=script&lang=js"

import "./InfoClienteRepeticao.vue?vue&type=style&index=0&id=46cf5a0b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf5a0b"]])

export default __exports__